module.exports = __webpack_public_path__ + "img/3WeChat.95033f15.svg";